/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/**
 *
 * IntegrationListenerLayout
 *
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { InputField, ToggleField, SidePanelActions } from 'cx-ui-components';
import styled from 'styled-components';
import IntegrationListenerForm from './form';

const Header = styled.h3`
  font-size: 28px;
  margin-bottom: 30px;
  color: #474747;
  font-weight: 700;
  display: inline-block;
`;

const Wrapper = styled.div`
  max-height: 50vh;
  overflow: auto;
  margin-bottom: 10px;
`;

export default function IntegrationListenerLayout(props) {
  return (
    <form onSubmit={props.handleSubmit} key={props.key}>
      {props.integrationType !== 'twilio' && props.integrationType !== 'ecg' ? (
        <Fragment>
          <Fragment>
            <Header>{`${props.initialValues.get('id') ? 'Updating Listener' : 'Creating new Listener'}`}</Header>
          </Fragment>

          <Wrapper>
            <InputField
              name="name"
              label="Name *"
              componentType="input"
              inputType="text"
              data-automation="integrationListenersName"
              disabled={props.isSaving}
            />
            <ToggleField
              name="active"
              label="Active"
              data-automation="integrationListenersActive"
              disabled={props.isSaving}
            />

            <IntegrationListenerForm
              currentEmail={props.currentEmail}
              googleOauthClientId={props.googleOauthClientId}
              googleOauthClientSecret={props.googleOauthClientSecret}
              incomingType={props.incomingType}
              initialValues={props.initialValues}
              integrationEmail={props.integrationEmail}
              integrationInitialValues={props.integrationInitialValues}
              integrationType={props.integrationType}
              isSaving={props.isSaving}
              key={props.key}
              msOauthClientId={props.msOauthClientId}
              msOauthClientSecret={props.msOauthClientSecret}
              msOauthPreferredUsernameListener={props.msOauthPreferredUsernameListener}
              oauthCredential={props.oauthCredential}
            />
          </Wrapper>
        </Fragment>
      ) : (
        <Fragment>
          <Fragment>
            <Header>{`${
              props.initialValues.get('key') !== '' ? 'Updating Global Param Value' : 'Creating new Global Param Value'
            }`}</Header>
          </Fragment>

          <Wrapper>
            <InputField
              name="key"
              label="Key *"
              componentType="input"
              inputType="text"
              data-automation="integrationGlobalDialParameterKey"
              disabled={props.isSaving}
            />
            <InputField
              name="value"
              label="Value *"
              componentType="input"
              inputType="text"
              data-automation="integrationGlobalDialParameterValue"
              disabled={props.isSaving}
            />
          </Wrapper>
        </Fragment>
      )}

      <SidePanelActions
        onCancel={props.onCancel}
        isSaving={props.isSaving}
        pristine={props.pristine}
        invalid={props.invalid}
      />
    </form>
  );
}

IntegrationListenerLayout.propTypes = {
  key: PropTypes.string,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onCancel: PropTypes.func,
  isSaving: PropTypes.bool,
  pristine: PropTypes.bool,
  invalid: PropTypes.bool,
  integrationType: PropTypes.string,
  incomingType: PropTypes.string,
  integrationEmail: PropTypes.string,
  oauthCredential: PropTypes.any,
  googleOauthClientId: PropTypes.string,
  googleOauthClientSecret: PropTypes.string,
  msOauthClientId: PropTypes.string,
  msOauthClientSecret: PropTypes.string,
  msOauthPreferredUsernameListener: PropTypes.string,
};
